import { useTranslation } from 'react-i18next';

import type { ForceLocationPickerDialogProps, Location } from './types';

import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

import { useChangeLocationMutation } from '@/mutations';

export const ForceLocationPickerDialog = ({
  locations,
  apiUrl,
}: ForceLocationPickerDialogProps) => {
  const { t } = useTranslation();
  const { mutate: changeLocation, isPending } = useChangeLocationMutation();
  const onLocationSelect = (id: number) => {
    changeLocation(
      { url: apiUrl, locationId: id },
      {
        onSuccess: (res) => {
          if (res?.status === 'ok') {
            window.location.reload();
          }
        },
      },
    );
  };

  return (
    <Dialog
      open={true}
      modal={true}
    >
      <DialogContent
        showCloseButton={false}
        onInteractOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
        className="sm:max-w-md"
        autoFocus={false}
      >
        <DialogHeader>
          <DialogTitle className="text-center">
            {t('Select Location')}
          </DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-2">
          {locations.map((location: Location) => (
            <Button
              key={location.id}
              variant="outline"
              className="w-full justify-start"
              onClick={() => onLocationSelect(location.id)}
              disabled={isPending}
            >
              {location.name}
            </Button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export type { ForceLocationPickerDialogProps, Location } from './types';
